/** The two capture-path operations a storage quota can abort. */
export type FieldSyncQuotaOperation = "stage-evidence" | "enqueue";

/**
 * A storage quota refused the write. Typed because a quota abort is a loud,
 * blocking, NON-LOSSY failure: the tester's evidence or queued document was not
 * written, the UI has to be able to name that specific cause, and the tester
 * has to be able to retry the same capture after freeing space. An untyped
 * throw surfaces as an anonymous sync failure, which is indistinguishable from
 * a transient one and invites a silent retry loop against a full disk.
 */
export class FieldSyncQuotaError extends Error {
  readonly operation: FieldSyncQuotaOperation;

  constructor(operation: FieldSyncQuotaOperation, cause?: unknown) {
    super(`field_sync_quota_exceeded:${operation}`, { cause });
    this.name = "FieldSyncQuotaError";
    this.operation = operation;
  }
}
